
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadComponent, type RouteObject } from 'Routes/index';

const ClientDocuments = lazy(() => import(`Pages/Screens/Office/Documents/Clients`));
const TaxClaimantDocuments = lazy(() => import(`Pages/Screens/Office/Documents/TaxClaimants`));

const DocumentsRoutes: RouteObject[] = [
    {
      path: 'documents',
      children: [
        {
          index: true,
          element: <Navigate to="/documents/clients" replace />,
        },
        {
          path: 'clients',
          element: <LoadComponent component={ClientDocuments} />,
        },
        {
          path: 'clients/:id',
          element: <LoadComponent component={ClientDocuments} />,
        },
        {
          path: 'tax-claimants',
          element: <LoadComponent component={TaxClaimantDocuments} />,
        },
        {
          path: 'tax-claimants/:id',
          element: <LoadComponent component={TaxClaimantDocuments} />,
        },
      ],
    },
]

export default DocumentsRoutes;